export default class Default {
  constructor( element ) {
    element.classList.add('javascript');
  }
}
